import { ArrowRightOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import React, { FunctionComponent, ReactNode } from 'react';
import { AutomationTemplateContainer } from '../../../AutomationTemplateContainer';
import { ReactComponent as DonkeyLand } from './Images/DonkeyLand.svg';
import { ReactComponent as UnicornLand } from './Images/UnicornLand.svg';
import styles from './TemplateBuilderComponents.module.css';

export const TemplateBuilderContainer: FunctionComponent<{
  children: ReactNode;
  enabled: boolean;
  confirm: () => void;
}> = props => {
  const { children, enabled, confirm } = props;
  const { activeTemplate } = AutomationTemplateContainer.useContainer();
  const title = activeTemplate?.template.title.replace('Our', '');
  return (
    <div className={styles.container}>
      <div className={styles.heading}>Customize your {title} Offer</div>
      <div className={styles.scroll}>
        <div className={styles.donkeyLand}>
          <DonkeyLand />
        </div>
        {children}
        <div className={styles.unicornLand}>
          <UnicornLand />
        </div>
        <div className={styles.buttonRow}>
          <Button
            css={{ container: styles.button }}
            disabled={!enabled}
            onClick={confirm}
            rightIcon={<ArrowRightOutlined />}
          >
            Let's go
          </Button>
          <div className={styles.buttonRowInfo}>
            You'll be able to reconfigure initial settings
          </div>
        </div>
      </div>
    </div>
  );
};
